

export enum PayeeTypes {
	PEER = "PEER",
	MERCHANT = "MERCHANT",
	TOPUP = "TOPUP",
	DOMESTIC = "DOMESTIC",
	EXTERNAL = "EXTERNAL",
}

// export const isTypePeerList = (value: Peer[] | Merchant[], type: PayeeTypes): value is Peer[] => {
// 	return (type === PayeeTypes.PEER);
// }

// export const isTypeMerchantList = (value: Peer[] | Merchant[], type: PayeeTypes): value is Merchant[] => {
// 	return (type === PayeeTypes.MERCHANT);
// }


export type UnionPayeesType = Peer | Merchant | TopupPayee | ExternalPaymentPayee | DomesticPaymentPayee;
export type UnionPayeesListType = Peer[] | Merchant[] | TopupPayee[] | ExternalPaymentPayee[] | DomesticPaymentPayee[];

export interface TopupPayee {
	sortByNickName: boolean;
	name: string;
	id: number;
	type: string;
	availablePaymentPriorities: string | null;
	vendorCode: string;
	payByTextAccountNumber: string;
	payByTextEnabled: boolean;
	payByTextDefaultAmount: string;
	customerKey: {
		countryCode: string;
		mobilePlan: string;
		accountNumber: string;
		selectedProductId: string;
	}
	targetName: string;
	vendorInstitutionId: string | number | null;
	vendorQRDisclaimer: string | null;
	payByTextDefaultAccountKey: string;
	vendorBillingHelp: string;
	creditUnionTransactionFee: number | null;
	nickname: string;
	fees: number[];
	merchantId: number;
	lastName: string;
	firstName: string;
}

export interface Peer {
	id: number;
	payByTextAccountNumber: string;
	payByTextEnabled: boolean;
	payByTextDefaultAmount: number | null;
	accountGroup: string;
	nickname: string;
	accountNumber: string;
	accountName: string;
	accountCurrency: string | null;
	reference: string;
	lastName: string;
	firstName: string;
}

export interface Merchant {
	sortByNickName: boolean;
	name: string;
	id: number;
	type: string;
	availablePaymentPriorities: string | null;
	vendorCode: string;
	payByTextAccountNumber: string;
	payByTextEnabled: boolean;
	payByTextDefaultAmount: number | null;
	customerKey: {
		businessName?: string;
		businessNumber?: string;
		referenceInformation: string;
		accountType: string;
		accountGroup: string;
		recipientName: string;
		accountNumber: string;
		invoiceName?: string;
		customerNumber?: string;
    meterNumber?: string;
	};
	targetName: string;
	vendorInstitutionId: string;
	vendorQRDisclaimer: string | null;
	payByTextDefaultAccountKey: string;
	vendorBillingHelp: string;
	creditUnionTransactionFee: number | null;
	nickname: string;
	accountCurrency: string;
	fees: number[];
	merchantId: number;
	lastName: string;
	firstName: string;
	meterNumber: string;
}

export interface ExternalPaymentPayee {
	sortByNickName: boolean;
	name: string;
	id: number;
	type: string;
	nickname: string;
	merchantId: number;
	targetName: string;
	payByTextEnabled: boolean;
	payByTextDefaultAmount: string;
	payByTextAccountNumber: string;
	customerKey: {
		referenceInformation?: string;
		accountType?: string;
		accountGroup?: string;
		recipientName?: string;
		accountNumber: string;
	}
	vendorCode: string;
	fees: ExternalPaymentFee[];
	availablePaymentPriorities: string | null;
	vendorInstitutionId: string | number | null;
	vendorBillingHelp: string;
	vendorQRDisclaimer: string | null;
	payByTextDefaultAccountKey: string;
	creditUnionOrWalletTransactionFee: number | null;
	firstName: string;
	lastName: string;
}

export interface ExternalPaymentFee {
	id: number;
	transferType: string;
	amountString: string;
	amount: DoubleRange;
	stringFinal: string;
	currency: {
		currencyCode: string;
		isoCurrencyCode: string;
		symbol: string;
		numericCode: string;
	}
}

export interface ExternalPaymentFeeOption extends ExternalPaymentFee {
	isDense: boolean;
	option: string;
	optionNote: string;
}

export interface DomesticPaymentPayee {
	sortByNickName: boolean;
	name: string;
	id: number;
	type: string;
	customerKey: {
		recipientName: string;
		currency: string;
		accountNumber: string;
	};
	targetName: string;
	vendorQRDisclaimer: string | null;
	creditUnionTransactionFee: number | null;
	payByTextDefaultAccountKey: string;
	vendorInstitutionId: string | number | null;
	vendorBillingHelp: string;
	availablePaymentPriorities: string | null;
	fees: number[];
	nickname: string;
	payByTextDefaultAmount: string;
	payByTextAccountNumber: string;
	payByTextEnabled: boolean;
	firstName: string;
	lastName: string;
	vendorCode: string;
	merchantId: number;
}

export interface OneTimeMerchant {
	id: number;
	domesticLimits: number | string | null;
	name: string;
	status: string;
	vendorCode: string;
	isRestricted: boolean;
	isBalanceAvailable: boolean;
	isRecurringPaymentEnabled: boolean;
	isOneTimePaymentEnabled: boolean;
	isExemptFromReceiverTransactionFee: boolean;
	institution: string;
	billingHelp: string;
	email: string;
	email2: string;
	externalDetailAvailable: boolean;
	helpMessages: {
		en: string;
		nl: string;
		fr: string;
		es: string;
	},
	maxAmountVal: number;
	minAmountVal: number;
	maxAmount: string;
	minAmount: string;
	qrDisclaimer: string;
	qrDisclaimers: any;
	nickname?: string;
}

export enum ManagePayeesMode {
	LIST = 'LIST',
	ADD = 'ADD',
	UPDATE = 'UPDATE',
	DELETE = 'DELETE',
};